import { storageUserGet } from '../storage/storageUser'
import { AccessLevelStatic } from '../@types/statics/access-level.static';

const usePermission = (featureId?: string): UsePermissionReturn => {

  const canCreate = (): boolean => {
    const user = storageUserGet();
    const userFeatures = user.features?.filter(x => x.featureId == featureId
      && (x.accessLevelId == AccessLevelStatic.edit.id || x.accessLevelId == AccessLevelStatic.editMine.id));
    return (userFeatures != null && userFeatures.length > 0);
  }

  const canEdit = (createdByUserId?: string, managerId?: string): boolean => {
    const user = storageUserGet();
    const userFeatures = user.features?.filter(x => x.featureId == featureId
      && (x.accessLevelId == AccessLevelStatic.edit.id || x.accessLevelId == AccessLevelStatic.editMine.id));
    let result = false;
    if (userFeatures != null && userFeatures.length > 0) {
      if (userFeatures.some(x => x.accessLevelId == AccessLevelStatic.edit.id)) {
        result = true;
      } else {
        result = (createdByUserId == user.id || managerId == user.resourceId);
      }
    }
    return result;
  }

  const canEditMine = (): boolean => {
    const user = storageUserGet();
    const userFeatures = user.features?.filter(x => x.featureId == featureId);
    let result = false;
    if (userFeatures) {
      for (let index = 0; index < userFeatures.length; index++) {
        const userFeature = userFeatures[index];
        if (userFeature.accessLevelId == AccessLevelStatic.edit.id)
          return false;
        else if (userFeature.accessLevelId == AccessLevelStatic.editMine.id)
          result = true;

      }
    }

    return result;
  }

  const canView = (specificFeatureId: string | undefined = undefined): boolean => {
    const user = storageUserGet();
    const userFeatures = user.features?.filter(x => x.featureId == featureId || x.featureId == specificFeatureId);
    const hasAccess = userFeatures?.some(x => x.accessLevelId != AccessLevelStatic.noAccess.id);
    return !!hasAccess;
  }

  return {
    canCreate,
    canEdit,
    canView,
    canEditMine
  }
}

export interface UsePermissionReturn {
  canCreate: () => boolean
  canEditMine: () => boolean
  canEdit: (createdByUserId?: string, managerId?: string) => boolean
  canView: (specificFeatureId?: string | undefined) => boolean
}

export default usePermission
